export enum WfxCarharttEnum {
    FABRIC = 'FABRIC',
    LABEL = 'LABEL',
    PACKAGINGTRIMS = 'PACKAGING TRIMS',
}


export enum TrimCardStatusEnum {
    OPEN = 'OPEN',
    DELETED = 'DELETED',
}

export enum ArticleTextileType {
    FABRICMASTER = 'FABRIC MASTER',
    TRIMMASTER = 'TRIM MASTER'
}

export enum TechPackFileType {
    PDF = 'PDF'
}

export enum WFXStatusEnum {
    PENDING_FOR_APPROVAL = "PENDING FOR APPROVAL",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED"
}